<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20 mar_l20">
        <div class="pagetitle mar_b20">{{ $t('set.idRecognition.title') }}</div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="APP ID" :required="true">
          <el-input
            v-model.trim="form.appId"
            autocomplete="off"
            :placeholder="$t('set.idRecognition.appIdPh')"
          ></el-input>
        </el-form-item>
        <el-form-item label="API KEY" :required="true">
          <el-input
            v-model.trim="form.appKey"
            autocomplete="off"
            :placeholder="$t('set.idRecognition.apiKeyPh')"
          ></el-input>
        </el-form-item>
        <el-form-item label="SECRET KEY" :required="true">
          <el-input
            v-model.trim="form.secretKey"
            autocomplete="off"
            :placeholder="$t('set.idRecognition.secretKeyPh')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from "@/api/set";

export default {
  data() {
    return {
      form: {
        ident: "identityCard",
        appId: "",
        appKey: "",
        secretKey: "",
      },
    };
  },
  created() {
    this.bus.$emit("loading", true);
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      getConfig(this.form).then((res) => {
        for (let key in res.data) {
          this.form[key] = res.data[key];
        }
        this.bus.$emit("loading", false);
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          postConfig(this.form).then((msg) => {
            this.$baseMessage(msg.msg, "success");
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.el-form-item__content {
  text-align: left;
}
.tsinput .el-input {
  width: 300px !important;
}
</style>
